module.exports = "<div class=\"savings-slider-result\">\n  <label>You save</label>\n  <span>{{ sagingsValue }}</span>\n</div>\n<nouislider [config]=\"sliderConfig\" [(ngModel)]=\"sliderValue\" (slide)=\"updateResult($event)\" (ngModelChange)=\"updateResult($event)\"></nouislider>"


//////////////////
// WEBPACK FOOTER
// ./resources/themes/pandax/bobtail/app/savings-slider/savings-slider.component.html
// module id = 566
// module chunks = 5